import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Paper, Select, Stack, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

interface Props {
    block: ButtonBlock;
    onChange: (content: any) => void;
    onDelete: () => void;
}

const ButtonBlockEditor = ({ block, onChange, onDelete }: Props) => {
    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <IconButton size="small" sx={{ cursor: "grab" }}>
                    <DragIndicatorIcon />
                </IconButton>
                <Box flex={1}>
                    <Stack spacing={2}>
                        <TextField
                            label="Button Text"
                            value={block.content.text}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    text: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="URL"
                            value={block.content.url}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    url: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                        />
                        <FormControl fullWidth size="small">
                            <InputLabel>Variant</InputLabel>
                            <Select
                                value={block.content.variant}
                                label="Variant"
                                onChange={(e) =>
                                    onChange({
                                        ...block.content,
                                        variant: e.target.value,
                                    })
                                }
                            >
                                <MenuItem value="contained">Contained</MenuItem>
                                <MenuItem value="outlined">Outlined</MenuItem>
                                <MenuItem value="text">Text</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl fullWidth size="small">
                            <InputLabel>Color</InputLabel>
                            <Select
                                value={block.content.color}
                                label="Color"
                                onChange={(e) =>
                                    onChange({
                                        ...block.content,
                                        color: e.target.value,
                                    })
                                }
                            >
                                <MenuItem value="primary">Primary</MenuItem>
                                <MenuItem value="secondary">Secondary</MenuItem>
                            </Select>
                        </FormControl>
                        <Box>
                            <Button
                                variant={block.content.variant}
                                color={block.content.color}
                                disabled
                            >
                                {block.content.text || "Button Preview"}
                            </Button>
                        </Box>
                    </Stack>
                </Box>
                <IconButton size="small" onClick={onDelete} color="error">
                    <DeleteIcon />
                </IconButton>
            </Stack>
        </Paper>
    );
};

export default ButtonBlockEditor;
